<template>
  <div>
    <v-data-table
      :headers="[
        { value: 'attribute' },
        { value: 'operator' },
        { value: 'value' },
        { value: 'edit' },
        { value: 'remove' },
      ]"
      :items="filterTermList"
      data-cy="listFilter-advanced-table"
      dense
      disable-pagination
      disable-sort
      hide-default-header
      hide-default-footer
      no-data-text="Use form above to create new search filters."
    >
      <template v-slot:item="{ item }">
        <tr>
          <td style="width: 200px">{{ item.attribute.label }}</td>
          <td style="width: 140px">{{ item.operator.label }}</td>
          <td>{{ formatValue(item.value) }}</td>
          <td style="width: 50px">
            <v-btn
              :data-cy="`listFilter-advanced-table-${item.attribute.name}-edit`"
              icon
              @click="$emit('set-filter-term-active', item)"
            >
              <v-icon size="15">far fa-edit</v-icon>
            </v-btn>
          </td>
          <td style="width: 50px">
            <v-btn
              :data-cy="`listFilter-advanced-table-${item.attribute.name}-delete`"
              icon
              @click="$emit('remove-filter-term', item.attribute.name)"
            >
              <v-icon size="15">far fa-trash-alt</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  methods: {
    formatValue(value) {
      if (value === null) {
        return "<null>";
      }

      if (!value) {
        return;
      }

      if (value && Array.isArray(value)) {
        return value.join(", ");
      }

      const { label } = value;

      if (label) {
        return label;
      }

      return value;
    },
  },
  props: {
    filterTermList: {
      required: true,
      type: Array,
    },
  },
};
</script>
